import React, { useState, useEffect } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import headerImage from "../../../../../assets/img/longarrow.jpg";
import GradientButton from "components/Buttons/GradientButton.js";
import ReusableInput from "components/Inputs/ReusableInput.js";
import { formatDate } from "utils/dateFormatter";

const FAQ_CATEGORIES = [
  { label: "Driver FAQ", value: "Driver FAQ" },
  { label: "Driver Partner", value: "Driver Partner" },
  { label: "General", value: "General" },
];

const EditFAQDrawer = ({ isOpen, onClose, faq, onUpdateFAQ }) => {
  const [formData, setFormData] = useState({
    faq_id: "",
    question: "",
    answer: "",
    category: "",
    created_at: "",
    updated_at: "",
  });

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    // Update formData whenever the faq prop changes
    if (faq) {
      setFormData((prev) => ({
        ...prev,
        ...faq,
        category: faq.category || "", // ensure controlled input
      }));
      setIsEditing(false); // reset to view mode when switching FAQ
    }
  }, [faq]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleToggleEdit = () => {
    if (isEditing) {
      // Save changes when in editing mode
      onUpdateFAQ(formData);
      setIsEditing(false);
    } else {
      // Enable editing mode
      setIsEditing(true);
    }
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={() => {
        setIsEditing(false);
        onClose();
      }}
      headerImage={headerImage}
      headerContent={<h2>{isEditing ? "Edit FAQ" : "View FAQ"}</h2>}
      bodyContent={
        <Stack spacing={4}>
          {/* Question */}
          <ReusableInput
            label="Question"
            name="question"
            value={formData?.question || ""}
            onChange={handleInputChange}
            placeholder="Enter the FAQ question"
            type="textarea"
            isReadOnly={!isEditing}
          />

          {/* Category */}
          <ReusableInput
            label="Category"
            name="category"
            value={formData?.category || ""}
            onChange={handleInputChange}
            type="select"
            options={FAQ_CATEGORIES}
            placeholder="Select FAQ category"
            isReadOnly={!isEditing}
          />

          {/* Answer */}
          <ReusableInput
            label="Answer"
            name="answer"
            value={formData?.answer || ""}
            onChange={handleInputChange}
            placeholder="Enter the FAQ answer"
            type="textarea"
            isReadOnly={!isEditing}
          />

          {/* Date Added */}
          <ReusableInput
            label="Date Added"
            name="dateAdded"
            value={formatDate(formData?.created_at) || ""}
            isReadOnly
            placeholder="Auto-generated"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton
            onClick={() => {
              setIsEditing(false);
              onClose();
            }}
            fontSize="15px"
            width="100px"
            height="40px"
          >
            Cancel
          </GradientButton>

          <GradientButton
            onClick={handleToggleEdit}
            fontSize="15px"
            width="100px"
            height="40px"
            isDisabled={
              isEditing &&
              (!formData.question || !formData.answer || !formData.category)
            }
          >
            {isEditing ? "Save" : "Edit"}
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditFAQDrawer;
